// extracted by mini-css-extract-plugin
export default {"input_block":"styled_input_block__Rh44A","input":"styled_input__pUhjk"};